import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import './Pages.css';
import './Work.css';

const REEL_VIDEO = '/media/ZaireColor-Reel-2025-compressed.mp4';
const REEL_POSTER = '/images/work/Cloudmaker-Still-1.webp';

const projects = [
    {
        title: 'Cloudmaker',
        type: 'Narrative',
        stills: [
            '/images/work/Cloudmaker-Still-1.webp',
            '/images/work/Cloudmaker-Still-2.webp',
            '/images/work/Cloudmaker-Still-3.webp',
            '/images/work/Cloudmaker-Still-4.webp',
        ],
    },
    {
        title: 'Red Bull',
        type: 'Documentary',
        stills: [
            '/images/work/Red-Bull-Still-1.webp',
            '/images/work/Red-Bull-Still-2.webp',
            '/images/work/Red-Bull-Still-3.webp',
            '/images/work/Red-Bull-Still-4.webp',
        ],
    },
    {
        title: 'BabyGold',
        type: 'Commercial',
        stills: [
            '/images/work/BabyGold-Still-1.webp',
            '/images/work/BabyGold-Still-2.webp',
            '/images/work/BabyGold-Still-3.webp',
            '/images/work/BabyGold-Still-4.webp',
        ],
    },
    {
        title: '6LACK — On Me',
        type: 'Music Video',
        stills: [
            '/images/work/6LACK-On-Me-Still-1.webp',
            '/images/work/6LACK-On-Me-Still-2.webp',
            '/images/work/6LACK-On-Me-Still-3.webp',
            '/images/work/6LACK-On-Me-Still-4.webp',
        ],
    },
    {
        title: 'The Secret Game',
        type: 'Documentary',
        stills: [
            '/images/work/Secret-Game-Still-1.webp',
            '/images/work/Secret-Game-Still-2.webp',
            '/images/work/Secret-Game-Still-3.webp',
            '/images/work/Secret-Game-Still-4.webp',
        ],
    },
    {
        title: 'CUWICU by Lint',
        type: 'Music Video',
        stills: [
            '/images/work/CUWICU-Still-1.webp',
            '/images/work/CUWICU-Still-2.webp',
            '/images/work/CUWICU-Still-3.webp',
            '/images/work/CUWICU-Still-4.webp',
        ],
    },
];

const allSlides = projects.flatMap(p => p.stills.map(src => ({ src })));

function Work() {
    const [index, setIndex] = useState(-1);

    let globalIndex = 0;

    return (
        <div className="page">
            <h1 className="page-title">Selected Work</h1>
            {/* <p className="page-subtitle">Selected color work</p> */}

            <div className="work-reel">
                <video
                    className="work-reel-video"
                    controls
                    playsInline
                    poster={REEL_POSTER}
                >
                    <source src={REEL_VIDEO} type="video/mp4" />
                </video>
            </div>

            {projects.map(project => {
                const startIndex = globalIndex;
                globalIndex += project.stills.length;

                return (
                    <section key={project.title} className="work-project">
                        <div className="work-project-header">
                            <h2 className="work-project-title">{project.title}</h2>
                            <span className="work-project-credit">{project.type}</span>
                        </div>
                        <div className="work-project-stills">
                            {project.stills.map((src, i) => (
                                <button
                                    type="button"
                                    key={src}
                                    className="work-still-item"
                                    onClick={() => setIndex(startIndex + i)}
                                    aria-label={`${project.title} still ${i + 1}`}
                                >
                                    <img src={src} alt="" loading="lazy" />
                                </button>
                            ))}
                        </div>
                    </section>
                );
            })}

            <Lightbox
                open={index >= 0}
                index={index}
                close={() => setIndex(-1)}
                slides={allSlides}
            />
        </div>
    );
}

export default Work;
